import { action, observable } from "mobx";
import { Condition } from "./Condition";
import type { ICondition } from "./Condition";
import { v4 } from "uuid";

export interface IConditionGroup extends ICondition {
    subRules: ICondition[];
    combineWith: ConditionGroupExpressionType;
}

export enum ConditionGroupExpressionType {
    And = "And",
    Or = "Or",
}

export class ConditionGroup implements IConditionGroup {
    public readonly id: string = v4();

    @observable public subRules: ICondition[];
    @observable public combineWith: ConditionGroupExpressionType;

    constructor();
    constructor(conditionGroup: IConditionGroup);
    constructor(conditionGroup?: IConditionGroup) {
        if (conditionGroup) {
            Object.assign(this, conditionGroup);
            this.subRules = conditionGroup.subRules.map((condition) =>
                Condition.ResolveConcreteCondition(condition),
            );
        } else {
            this.subRules = [];
            this.combineWith = ConditionGroupExpressionType.And;
        }
    }

    @action
    public setCombineWith(combineWith: ConditionGroupExpressionType) {
        this.combineWith = combineWith;
    }

    @action
    public addSubRule(condition: ICondition) {
        this.subRules.push(condition);
    }

    public static isConditionGroup(
        condition: ICondition,
    ): condition is IConditionGroup {
        return (
            Object.hasOwn(condition, "subRules") &&
            Object.hasOwn(condition, "combineWith")
        );
    }
}
